<template>
  <div class="content">
      <el-breadcrumb separator="/" class="top-div">
        <el-breadcrumb-item :to="{ path: '/share/current' }">项目管理</el-breadcrumb-item>
        <el-breadcrumb-item>开票时间</el-breadcrumb-item>
      </el-breadcrumb>
      <el-divider></el-divider>
      <div class="proname">
        <div style="height: 32px;line-height: 32px">
          项目名称：<span style="font-weight: 700">{{proname}}</span>
        </div>
        <div>
          <el-button type="primary" class="btn-add" @click="comedit('row','new')">新增开票</el-button>
        </div>
      </div>

      <el-table
        :data="tableData"
        border
        :header-cell-style="{ background: '#f6f9ff',color:'#7c8db5'}" :cell-style="{color:'#25396f'}"
      >
        <el-table-column
          label=""
          prop="stage"
          align="center"
        >
          <template slot-scope="scope">
            第{{scope.row.stage}}笔
          </template>
        </el-table-column>
        <el-table-column
          label="开票金额（万）"
          prop="billing_amount"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="开票时间"
          prop="invoicing_date"
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span class="caozuo"  @click="comedit(scope.$index, scope.row)" style="color:#347ae2;cursor: pointer;">修改</span>
            <span class="caozuo"  @click="delColomn(scope.row.id)" style="color:#ec4b4b;cursor: pointer;">删除</span>
          </template>
        </el-table-column>
      </el-table>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      class="diago"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="auto" :rules="rules">
        <el-form-item label="开票时间：" prop="plan_time">
          <!--        <el-input style="width:300px" v-model="form.plan_time" placeholder="请输入回款时间"></el-input>-->
          <el-date-picker
            v-model="form.plan_time"
            type="date"
            value-format="yyyy-MM-dd"
            style="width:300px"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="开票金额：" prop="collection_amount">
          <el-input style="width:300px" v-model="form.collection_amount" placeholder="请输入金额"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false" class="btn-cancel">取 消</el-button>
            <el-button type="primary" @click="uodata" class="btn-submit1">确 定</el-button>
        </span>
    </el-dialog>

  </div>
</template>

<script>
import {get_billing, del_billing, create_billing, mod_billing} from "../../api/user";

export default {
  data(){
    return{
      project_id:'',
      proname:'',
      tableData:[],
      dialogVisible:false,
      title:'',
      form:{
        projectid:'',
        stage:'',
        collection_amount:'',
        plan_time:''
      },
      title1:'',
      rules: {
        plan_time: [
          { required: true, message: '请选择开票时间', trigger: 'change' }
        ],
        collection_amount: [
          { required: true, message: '请输入回款金额', trigger: 'change' }
        ],
      },
    }
  },
  methods:{
    uodata() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if(this.form.name == '' || this.form.comp == ''){
            this.$message.warning('请完善信息后再提交！')
            return
          }
          if(this.title1 == 'xg'){
            if(this.dialogVisible) {
              let params = {
                projectid: this.form.projectid,
                billingid: this.form.collectionplanid,
                stage: this.form.stage,
                billing_amount: this.form.collection_amount,
                invoicing_date: this.form.plan_time
              }
              mod_billing(params).then(res => {
                if (res.code === 200) {
                  this.dialogVisible = false
                  this.$message.success('修改成功')
                  this.getData(this.project_id)
                } else {
                  this.$message.error(res.msg)
                }
              })
            }
          }else{
            if(this.dialogVisible) {
              let params = {
                projectid: this.form.projectid,
                // collectionplanid:this.form.collectionplanid,
                stage: this.form.stage,
                billing_amount: this.form.collection_amount,
                invoicing_date: this.form.plan_time
              }
              create_billing(params).then(res => {
                if (res.code === 200) {
                  this.dialogVisible = false
                  this.$message.success('添加成功')
                  this.getData(this.project_id)
                } else {
                  this.$message.error(res.msg)
                }
              })
            }
          }
        } else {
          return false;
        }
      });
      //
      //
      // }
    },

    delColomn(id){
      this.$confirm('确定删除该记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            billingid:id
          }
          del_billing(params).then(res => {
            if(res.code == 200){
              this.$message.success('删除成功')
              this.getData(this.project_id)
            }else{
              this.$message.error(res.msg)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    //新增或修改 - 计划
    comedit(index, row) {
      if(row != 'new') {
        this.title1 = 'xg'
        this.title = '修改回款计划-第'+row.stage+'笔'
        this.form.projectid = this.project_id
        this.form.stage = row.stage
        this.form.collection_amount = row.billing_amount
        this.form.plan_time = row.invoicing_date
        this.form.collectionplanid = row.id
        this.dialogVisible = true
      }else{
        let weizhi = this.tableData.length == 0 ? 1 :parseInt(this.tableData[this.tableData.length-1].stage)+1
        // console.log(weizhi)
        this.title1 = 'xz'
        this.title = '新增回款计划-第'+weizhi+'笔'
        this.form.projectid = this.project_id
        this.form.stage = weizhi
        this.form.collection_amount = ''
        this.form.plan_time = ''
        this.dialogVisible = true
      }
    },

    getData(id){
      let paramas = {
        projectid:id
      }
      get_billing(paramas).then(res=>{
        if(res.code == 200){
          this.tableData = res.data
        }
      })
    },

  },
  mounted() {
    this.project_id = this.$route.query.id
    this.proname =  this.$route.query.name
    this.getData(this.project_id)
  }
}
</script>

<style scoped>
.top-div{
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #25396f;
}
.proname{
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  font-size: 18px;
  margin-bottom: 20px;
  height: 32px;
  line-height: 32px;
}
.diago >>> .el-dialog{
  min-width: 430px;
}
</style>



// WEBPACK FOOTER //
// src/views/share/kpsj_xq.vue